// import Vue from 'vue'

export const createDataTypeValue = (value = []) => {
    return {
        'value': {
            value,
        },
    }
}

export default {
    createDataTypeValue,
}
